<template>
<div class="content">
  <div class="largeTitile" >检验报告朔源</div> 
  <div class="largeTitile" >{{ date }}</div> 
  <div class="info" v-if="customerCode">
    <table>
      <thead>
        <tr>
          <th colspan="2"> 溯源信息 </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">公司名称</th>
          <td>{{ info.companyName }}</td>
        </tr>
        <tr>
          <th scope="row">溯源商品分类</th>
          <td>{{ info.traceabilityType }}</td>
        </tr>
        <tr>
          <th scope="row">运输车辆</th>
          <td>{{ info.plateNo }}</td>
        </tr>
        <tr>
          <th scope="row">发货时间</th>
          <td>{{ info.deliveryTime | dateFil }}</td>
        </tr>
        <tr>
          <th scope="row">发往何地</th>
          <td>{{ info.customerShorthand }}</td>
        </tr>
      </tbody>
      <!-- <tfoot>
        <tr>
          <th scope="row" colspan="2">Average age</th>
        </tr>
      </tfoot> -->
    </table>
  </div>
  <div class="license">
    <div class="license-item">
      <span>营业执照</span>
      <img style="width:100%" :src="info.businessLicense" alt="" @click="onPreviewImg([info.businessLicense])" />
    </div>
    <div class="license-item">
      <span>食品流通许可证</span>
      <img style="width:100%" :src="info.foodBusinessLicense" alt="" @click="onPreviewImg([info.foodBusinessLicense])" />
    </div>
  </div>
  <van-image-preview v-model="showImgModel" :images="previewImagesList" />

  <div v-for="(item,name,index) in list" :key='index'>
      <div v-for="v in item" :key="v.subscribeTraceabilityId">
        <div v-if='v.fileType == 0'>
          <div class="titile"> 
            <span class="category">{{v.traceabilityLabel}}</span ><span class="name">{{v.name}}</span>
          </div>
          <v-touch @tap='taptap(v)' :swipe-options="{ direction: 'horizontal'}" @swipeleft="left(v.traceabilityLabel,v.subscribeTraceabilityId)" @swiperight="right(v.traceabilityLabel,v.subscribeTraceabilityId)">
            <div class="pdf pdfBox"  >
                <pdf
                :src="v.fileUrl" 
                :page="v.currentPage"
                @num-pages="v.pageCount=$event" 
                @page-loaded="pageLoaded" 
                @loaded="v.currentPage = 1">
                </pdf>
                <div class="footer">{{v.currentPage}}/{{v.pageCount}}</div>
            </div>
          </v-touch>
        </div>
        <div  v-if='v.fileType == 1'>
          <div class="titile"> 
            <span class="category">{{v.traceabilityLabel}}</span><span class="name">{{v.name}}</span>
          </div>
          <van-image @click="showPopup"  width="100%" height="auto"  :src="v.fileUrl"/>
        </div>
      </div>
  </div>
  <van-popup @click="closePop" v-model="show"  class="imgPopup">
    <v-touch @pinchin="growLarger" @pinchout="growSmall">
      {{scaleFun}}
      <!-- <div class='large_pic1'> -->
        <img  :src="picurl" alt="" :style="scaleFun" class='large_pic' >
      <!-- </div> -->
    </v-touch>
  </van-popup>
  <van-popup v-model="show1" class="imgPopup" @click="closePop1">
    <v-touch  @pinchin="growLarger" @pinchout="growSmall"  :swipe-options="{ direction: 'horizontal'}"  @swipeleft="left1(pdfList.traceabilityLabel,pdfList.subscribeTraceabilityId)" @swiperight="right1(pdfList.traceabilityLabel,pdfList.subscribeTraceabilityId)">
      <div ref="zoom" class="pdf pdfBox1" :style="scaleFun"  >
          <pdf
          :src="pdfList.fileUrl" 
          :page="pdfList.currentPage"
          @num-pages="pdfList.pageCount=$event" 
          @page-loaded="pageLoaded" 
          @loaded="pdfList.currentPage=1 "> 
          </pdf>
          <div class="footer1">{{pdfList.currentPage}}/{{pdfList.pageCount}}</div>
      </div>
    </v-touch>
  </van-popup>
</div>
</template>
<script>
import pdf from 'vue-pdf'
// import Hammer from 'hammerjs';
// import {zoomElement} from '../util/zomm'
// import pdf from 'vue-pdf-app'
// import { showImagePreview } from 'vant';
  export default {
    components: {pdf},
    props:{
      pathurl: { type: String },
    },
    data () {
      return {
        showImgModel: false,
        previewImagesList: [],
        info: {}, 
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数 
        fileType: 'pdf', // 文件类型
        // src: "", // pdf文件地址
        src: "http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf", // pdf文件地址
        date:'',
        customerCode: '',
        list:{},
        picurl:'',
        show:false,
        show1:false,
        pdfList:'',
        aa:'',
        scale:1,
      }
    }, 
    async created () {
      this.src = pdf.createLoadingTask(this.src)
      const { date, customerCode = '' } = this.$route.query
      let arr  = date.split('')
      arr.splice(4,0,'-')
      arr.splice(7,0,'-')
      this.date = arr.join('')      
      this.customerCode = customerCode

      const res = await this.$axios.get(`subscribe/subscribeTraceability/show/code?time=${this.date}&customerCode=${customerCode}`)
      const resData = res.data.data

      this.info = resData
      this.list = resData.dtlMap
      for (let key in this.list ) {
        this.list[key].forEach( (v) => {
          this.$set(v,'currentPage',0)
          this.$set(v,'pageCount',0)
        })
      } 
    } ,
    mounted() {
    },
    computed:{
      scaleFun() {
        let scale = this.scale;
        return `transform:scale(${scale})`
      }
    },
    methods: {
      onPreviewImg(value) {
        this.previewImagesList = value
        this.showImgModel = true
      },
      left(name,vid) {
         let currentArr = this.list[name].find(v => v.subscribeTraceabilityId == vid)
        if(currentArr.currentPage < currentArr.pageCount ) {
          currentArr.currentPage++
        }
      },
      right(name,vid) {
        let currentArr = this.list[name].find(v => v.subscribeTraceabilityId == vid)
        if(this.currentPage > 1 ) {
          currentArr.currentPage--
        }
      },
      left1() {
        if(this.pdfList.currentPage < this.pdfList.pageCount ) {
          this.pdfList.currentPage++
        }
      },
      right1() {
        if(this.currentPage > 1 ) {
          this.pdfList.currentPage--
        }
      },
      taptap(v) {
        this.pdfList = v
        this.show1 = true
      },
      // pdf加载时
      loadPdfHandler () {
        this.currentPage = 1 // 加载的时候先加载第一页
      },
      pageLoaded(v) {
        this.currentPage = v
      },
      showPopup(e) {

        this.picurl = e.target.currentSrc
        this.show = true;
      },
      growLarger(e) {
        this.scale = e.scale
      },
      growSmall(e) {
        this.scale = e.scale
      },
      closePop() {
        this.show = false
        this.scale = 1
      },
      closePop1() {
        this.show1 = false
        this.scale = 1

      },
    }
  }

</script>
<style scoped>
.license {
  display: flex;
  justify-content: center;
  .license-item {
    width: 45%;
    margin: 10px;
  }
  span {
    display: block;
    padding: 10px 0;
    margin-bottom: 10px;
    text-align: center;
    background-color: #e4f0f5;
  }
}
table {
  margin: 20px auto;
  border-collapse: collapse;
  border: 2px solid rgb(140 140 140);
  font-family: sans-serif;
  font-size: 0.8rem;
  letter-spacing: 1px;
}

thead {
  background-color: rgb(228 240 245);
}

th,
td {
  border: 1px solid rgb(160 160 160);
  padding: 8px 10px;
}

td:last-of-type {
  text-align: center;
}

tbody > tr:nth-of-type(even) {
  background-color: rgb(237 238 242);
}

tfoot th {
  text-align: right;
}

tfoot td {
  font-weight: bold;
}

  .footer {
    width: 40px;
    height: 15px;
    line-height: 15px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 450px;
    right: 50px;
    border-top-left-radius:10px;
    border-top-right-radius:10px;
    border-bottom-left-radius:10px;
    border-bottom-right-radius:10px;
    color:#f6ecec;
    text-align: center;
  }
  .footer1 {
    width: 40px;
    height: 15px;
    line-height: 15px;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 400px;
    right: 50px;
    border-top-left-radius:10px;
    border-top-right-radius:10px;
    border-bottom-left-radius:10px;
    border-bottom-right-radius:10px;
    color:#f6ecec;
    text-align: center;
  }
  .pdfBox {
    position: relative;
  }
  .pdfBox1 {
    position: fixed;
    width: 300px;
    height: 500px;
    top: 20%;
    left: 15%;
  }
  .category {
    font-size: 23px;
    font-weight: 700;
    margin-right: 20px;
    color: #205792;
  }
  .name {
    font-size: 20px;
    font-weight: 500;
    color: #205792;
  }
  .titile {
  background-color: #E8EEF4;
  border-radius: 10px;
  padding: 0 10px;
  margin-top: 10px;
  margin-bottom: 15px;
  height: 70px;
  line-height: 70px;
  }
  .content {
    padding: 0 20px;
    /* margin-top: 10px; */
    background-color: #fff;
  }
  .largeTitile {
    height: 60px;
    background-color: #15385e;
    font-size: 20px;
    line-height: 60px;
    text-align: center;
    color: #fff;
    font-weight: 700;
    margin: 0 -20px;
    margin-bottom:20px ;
  }
  .large_pic {
    width: 100%;
    height: auto;
    display: block;
    /* position: fixed; */
    margin: 0 auto;
    /* top: 200px;
    left: 0; */
    /* transform:scale() */
  }
  .large_pic1 {
    text-align: center;
    margin: auto;
  }
    .imgPopup {
      width: 100%;
      height: 100%;
      background-color: #000;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
</style>